import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  Preloader,
  Link,
  Popup,
  Heading,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default class TvChannels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      descriptionId: null,
    };
  }

  toggleDescription = (id) => {
    const { descriptionId } = this.state;
    this.setState({
      descriptionId: descriptionId === id ? null : id,
    });
  }

  render() {
    const { list, packetDescription } = this.props;
    const { descriptionId } = this.state;

    return (
      <div className={cx('component')}>
        {packetDescription && (
          <div className={cx('description')}>
            {packetDescription}
          </div>
        )}

        {list.length ? (
          <div className={cx('list')}>
            {list.map((channel, index) => (
              <div key={index} className={cx('channel')}>
                <div className={cx('channelImage')}>
                  {channel.imageUrl ? (
                    <img src={channel.imageUrl} alt="" />
                  ) : (
                    <div className={cx('channelImagePlaceholder')}>
                      ?
                    </div>
                  )}
                </div>
                <div className={cx('channelName')}>
                  {channel.description || channel.details ? (
                    <Link onClick={() => this.toggleDescription(channel.tunerPosition)}>
                      {channel.name}
                    </Link>
                  ) : channel.name}
                </div>

                {descriptionId === channel.tunerPosition && (
                  <Popup
                    className={cx('channelDescription')}
                    onClose={() => this.toggleDescription(channel.tunerPosition)}
                    opened
                  >
                    <Heading level={1}>
                      <span className={cx('popupHeadingName')}>
                        {channel.name}
                      </span>
                      {channel.imageUrl && (
                        <img
                          className={cx('popupHeadingImage')}
                          src={channel.imageUrl}
                          alt=""
                        />
                      )}
                    </Heading>
                    <div className={cx('popupDescription')}>
                      {channel.description}
                      <br />
                      <br />
                      {channel.details}
                    </div>
                  </Popup>
                )}
              </div>
            ))}
          </div>
        ) : (
          <Preloader
            className={cx('preloader')}
            size="64"
          />
        )}
      </div>
    );
  }
}

TvChannels.propTypes = {
  list: PropTypes.array,
  packetDescription: PropTypes.string,
};
